var fileNameInput = document.querySelector('#fileName');
var file = document.querySelector('#file');

file.addEventListener('change', function () {
    if ($(file).val() !== '') {
        fileNameInput.innerHTML = "Załączono CV";
        fileNameInput.style = 'background-color:#2ecc71;color:white;';
    }
});


$('.box .col-sm-3').hover(function() {
    $('.about').attr('style','left: 300px');


}, function() {
});